import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { fetchApi } from "../utlis/axios";
import { useNavigate } from "react-router-dom";
import { IoMdClose } from "react-icons/io";

const PostCase = ({ showModal, setShowModal }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [caseFiles, setCaseFiles] = useState([]);
  const [previews, setPreviews] = useState([]);

  const [formValues, setFormValues] = useState({
    title: "",
    description: "",
    pin_address: "",
    manual_complete_address: "",
    required_amount: "",
    category: "",
    contact_detail: {
      name: "",
      email: "",
      phonenumber: "",
    },
  });

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden"; // disable body scroll
    } else {
      document.body.style.overflow = "auto"; // enable again
    }
    return () => {
      document.body.style.overflow = "auto"; // cleanup
    };
  }, [showModal]);

  // File upload handler
  const sendFiles = async (e) => {
    const newFiles = e.target.files;
    const updatedFiles = [...caseFiles];
    const updatedPreviews = [...previews];

    for (let i = 0; i < newFiles.length; i++) {
      const file = newFiles[i];
      updatedFiles.push(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        updatedPreviews.push(e.target.result);
        setPreviews([...updatedPreviews]);
      };
      reader.readAsDataURL(file);
    }

    setCaseFiles(updatedFiles);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const data = new FormData();
      data.append("title", formValues?.title);
      data.append("description", formValues?.description);
      data.append("pin_address", formValues?.pin_address);
      data.append(
        "manual_complete_address",
        formValues?.manual_complete_address
      );
      data.append("required_amount", formValues?.required_amount);
      data.append("contact_detail", JSON.stringify(formValues?.contact_detail));

      caseFiles.forEach((file) => data.append("files", file));

      const result = await fetchApi.post("case/", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (result?.status === 201) {
        toast.success("Your case was posted successfully");
        navigate("/casesfeeds");
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="fixed inset-0 z-[100] flex justify-center ">
    {/* backdrop */}
    <div
      className="absolute inset-0 bg-black/50"
      onClick={() => setShowModal(false)}
    ></div>

    {/* modal wrapper */}
    <div className="flex items-center justify-center overflow-y-auto w-full min-h-screen py-8 md:py-16 px-4">
      <div className="relative z-[200] w-full max-w-4xl my-auto">
        <div className="bg-[#FCFBF7] rounded-3xl shadow-xl">
          {/* Close button */}
          <button
            className="absolute w-max top-4 right-4 text-gray-700 shadow-none bg-[#edf7f5] p-1 rounded-full cursor-pointer  hover:text-gray-700 text-2xl"
            onClick={() => setShowModal(false)}
          >
            <IoMdClose className="text-black"/>
            </button>

            {/* Header */}
            <div className="mx-6 border-b border-[#444444] pt-4 pb-2">
              <h2 className="text-3xl font-bold text-gray-800">
                Post Your Case
              </h2>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit} className="sm:px-6 px-[16px] py-6 space-y-6" style={{width:'100%'}}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Full Name */}
                <div>
                  <label className="block text-gray-700 mb-1 font-semibold text-lg">Full Name</label>
                  <input
                    type="text"
                    placeholder="Enter your full name"
                    className="w-full rounded-md border border-gray-300 px-3 py-2 "
                    value={formValues.contact_detail.name}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        contact_detail: {
                          ...formValues.contact_detail,
                          name: e.target.value,
                        },
                      })
                    }
                    required
                  />
                </div>
                {/* Email */}
                <div>
                  <label className="block text-gray-700 mb-1 font-semibold text-lg">Email</label>
                  <input
                    type="email"
                    placeholder="Enter your email address"
                    className="w-full rounded-md border border-gray-300 px-3 py-2"
                    value={formValues.contact_detail.email}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        contact_detail: {
                          ...formValues.contact_detail,
                          email: e.target.value,
                        },
                      })
                    }
                    required
                  />
                </div>
                {/* Phone Number */}
                <div>
                  <label className="block text-gray-700 mb-1 font-semibold text-lg">
                    Phone Number
                  </label>
                  <input
                    type="number"
                    placeholder="Enter your phone number"
                    className="w-full rounded-md border border-gray-300 px-3 py-2 "
                    value={formValues.contact_detail.phonenumber}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        contact_detail: {
                          ...formValues.contact_detail,
                          phonenumber: e.target.value,
                        },
                      })
                    }
                    required
                  />
                </div>
                {/* Case Title */}
                <div>
                  <label className="block text-gray-700 mb-1 font-semibold text-lg">Case Title</label>
                  <input
                    type="text"
                    placeholder="Enter case title"
                    className="w-full rounded-md border border-gray-300 px-3 py-2 "
                    value={formValues.title}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        title: e.target.value,
                      })
                    }
                    required
                  />
                </div>
                {/* Pin Location */}
                <div>
                  <label className="block text-gray-700 mb-1 font-semibold text-lg">
                    Pin Location
                  </label>
                  <input
                    type="text"
                    placeholder="Enter pin location"
                    className="w-full rounded-md border border-gray-300 px-3 py-2"
                    value={formValues.pin_address}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        pin_address: e.target.value,
                      })
                    }
                  />
                </div>
                {/* Manual Address */}
                <div>
                  <label className="block text-gray-700 mb-1 font-semibold text-lg">
                    Manual Address
                  </label>
                  <input
                    type="text"
                    placeholder="Enter manual address"
                    className="w-full rounded-md border border-gray-300 px-3 py-2"
                    value={formValues.manual_complete_address}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        manual_complete_address: e.target.value,
                      })
                    }
                  />
                </div>
                {/* Required Amount */}
                <div>
                  <label className="block text-gray-700 mb-1 font-semibold text-lg">
                    Required Amount
                  </label>
                  <input
                    type="number"
                    placeholder="Enter required amount"
                    className="w-full rounded-md border border-gray-300 px-3 py-2"
                    value={formValues.required_amount}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        required_amount: e.target.value,
                      })
                    }
                  />
                </div>
                {/* Category */}
                <div>
                  <label className="block text-gray-700 mb-1 font-semibold text-lg">Category</label>
                  <select
                    className="w-full rounded-md border border-gray-300 px-3 py-2"
                    value={formValues.category}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        category: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Category</option>
                    <option value="healthcare">Healthcare</option>
                    <option value="education">Education</option>
                    <option value="nutrition">Nutrition</option>
                    <option value="infrastructure">Infrastructure</option>
                  </select>
                </div>
              </div>

              {/* File Upload */}
              <div>
                <label className="block text-gray-700 mb-1 font-semibold text-lg">
                  Case Attachments
                </label>
                <input
                  type="file"
                  multiple
                  onChange={sendFiles}
                  className="w-full border rounded-md px-3 py-2"
                />
              </div>

              {/* Description */}
              <div>
                <label className="block text-gray-700 mb-1 font-semibold text-lg">Description</label>
                <textarea
                  placeholder="Add your description"
                  className="w-full rounded-md border border-gray-300 px-3 py-2 h-28"
                  value={formValues.description}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      description: e.target.value,
                    })
                  }
                />
              </div>

              {/* Submit */}
              <div className="flex justify-start">
                <button
                  type="submit"
                  disabled={loading}
                  className="primary-button w-max !font-normal font-quicksand"
                >
                  {loading ? "Submitting..." : "Submit Support Case"}
                </button>
              </div>
            </form>
          </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PostCase;
